import {  graphql, useStaticQuery } from 'gatsby'
const casestudy = ({src}) => {

    const data = useStaticQuery(graphql`query casestudyQuery {
  allGhostPost(
    sort: {published_at: DESC}
    filter: {tags: {elemMatch: {name: {eq: "#casestudy"}}}}
  ) {
    nodes {
      id
      title
      slug
      tags {
        name
        slug
      }
      feature_image
      excerpt
    }
  }
}`)
    //console.log(data.allGhostPost.nodes)
    const items = []
    {data.allGhostPost.nodes.map((post, index) => {
        const url = `/casestudy/${post.slug}/`
       // console.log(items)

        items.push(
            <article className=" col-12 col-sm-6 col-md-6 col-lg-6 item d-left" key={index}>
                <div className="bg-white brad-16 p-4 shadowN box-shadow">
                    <div className="overflow brad-16">
                        <a href={ url } className="featured-image" title={ post.title }>
                        <img width="340" height="208" className="img-responsive lozad" src={ post.feature_image } alt={ post.title} loading="lazy" style={{height:"100%"}}/>
                        </a>
                    </div>
                    <div className="guideDetailsLink pb-0">
                        <p className="post_titel"><a href={ url } title={ post.title }> { post.title }</a></p>
                        <div className="blog_excerpt" >{ post.excerpt }</div>
                        <div className=" flw100"><a href={ url } title={ post.title } className = "links">Read More <span className="campaignSprite"></span></a></div>
                    </div>
                </div>
            </article>)
    })}

    return (<>
        <section className="greyBackgroundN faqN pb-5">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center mb-0">Redefining corporate wellness in your organization</div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 innerSpace px-0">
                        <div className="clientsLogo onlineBox">
                            {/* <div className="quislex campaignSprite"></div> */}
                            {/* <div className="cyda campaignSprite"></div>
                            <div className="iim campaignSprite"></div>
                            <div className="idb campaignSprite"></div>
                            <div className="rbs campaignSprite"></div>
                            <div className="rcss campaignSprite"></div>
                            <div className="carter campaignSprite"></div>
                            <div className="pphp campaignSprite"></div>
                            <div className="orion campaignSprite"></div>
                             <div className="esaf campaignSprite"></div>
                             <div className="hope campaignSprite"></div>
                             <div className="joye campaignSprite"></div>
                             <div className="allston campaignSprite"></div>
                            <div className="randstad campaignSprite"></div>
                            <div className="coviti campaignSprite"></div>
                            <div className="repid campaignSprite"></div> */}
                            <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1726488372/VantageFit/2024/casestudy-logos.png" alt="client logos"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="greyBackgroundN" >
            <div className="container customCampaignContainer " >
                <div className="row_elementor loop ">
                <div className="col-lg-9 headpost pclr mob_0Spc" id="caseStudy">{items}</div>
                <div className="col-lg-3" id="downloadNow">
                    <div className="downloadsection text-center sticky innerspace compny_background hidden-xs hidden-sm">
                        <div className="sideheading">Download our eBook for Free</div>
                        <div className="b15">A Complete Guide To Corporate Wellness Programs</div>
                        <img loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/website/vantagefit-bookcover_compress.png" alt="wellnessprogram" className="imagesticky lozad" width="179" height="235"/>
                        <div className="transform "><a className="popup-youtube banner_btn white_button button-style color_white" href="https://www.vantagefit.io/vantagefit-corporate-wellness-guide/"  >Free Download </a>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default casestudy

